import { Fragment, useContext } from "react";
import { FiShoppingBag, FiX } from "react-icons/fi";
import './index.scss'
import { CartItem } from "components/CartItem";
import { AppContext } from "App";
import { useSelector } from "react-redux";
import { getCartSelector, geTotalCartPrice } from "slices/cart";

interface Props { }

export function FloatingShopCart(props: Props) {
    const cartItems = useSelector(getCartSelector)
    const totalPrice = useSelector(geTotalCartPrice)
    const { show, handleCloseCart } = useContext(AppContext)


    return (
        <Fragment>
            {show && (
                <Fragment>
                    <div className="floatingShopCart">
                        <div className="bg-grey floatingShopCart-top">
                            <div className="floatingShopCart-top-name"><i><FiShoppingBag /></i> shopping cart</div>
                            <div className="floatingShopCart-top-close" onClick={handleCloseCart}>
                                <i><FiX /></i>
                                <span>close</span>
                            </div>
                        </div>
                        <div className="floatingShopCart-center">
                            {cartItems.map(i => (
                                <CartItem key={i.id} item={i} />
                            ))}
                        </div>
                        <div className="relative">
                        </div>
                        <div className="floatingShopCart-bottom">
                            <div className="floatingShopCart-bottom-content">
                                <span>proceed to checkout</span>
                                <span className="amount">${totalPrice}</span>
                            </div>
                        </div>
                    </div>
                    <div className="close-shadow" onClick={handleCloseCart}>

                    </div>
                </Fragment>
            )}
        </Fragment>

    )
}